import {
  AcademicCapIcon,
  ClockIcon,
  DocumentCheckIcon,
  EyeSlashIcon,
  MagnifyingGlassIcon,
  MapPinIcon,
  ServerStackIcon
} from '@heroicons/react/24/outline'

import { prog } from '../../motion'
import { Line } from '../kit'

// Ein horizontaler Streifen großer Karten, der mit dem Scroll vorbeizieht
const CARDS = [
  {
    Icon: ServerStackIcon,
    tone: 'blue',
    title: 'ISO 27001',
    text: 'Hosting auf ISO-27001-zertifizierten Servern.'
  },
  {
    Icon: MapPinIcon,
    tone: 'white',
    title: 'Hosting in Deutschland',
    text: 'Aivy läuft auf Servern in Deutschland.'
  },
  {
    Icon: DocumentCheckIcon,
    tone: 'green',
    title: 'DSGVO-konform',
    text: 'Datenschutz nach europäischem Recht, von Anfang an mitgedacht.'
  },
  {
    Icon: ClockIcon,
    tone: 'yellow',
    title: 'Automatische Löschung',
    text: 'Talente werden nach der Frist gelöscht, die du festlegst.'
  },
  {
    Icon: EyeSlashIcon,
    tone: 'pink',
    title: 'Score ausblendbar',
    text: 'Den Passungsscore im Report blendest du per Einstellung aus.'
  },
  {
    Icon: AcademicCapIcon,
    tone: 'white',
    title: 'DIN 33430',
    text: 'Anforderungsanalyse nach den Best Practices der Norm.'
  },
  {
    Icon: MagnifyingGlassIcon,
    tone: 'blue',
    title: 'Nachvollziehbar',
    text: 'Regelbasierte Passung, die du jedem Talent erklären kannst.'
  }
]

export default function CinSecurity() {
  return (
    <div className='cin-full'>
      <div className='cin-pad cin-pad--top'>
        <Line at={[0, 0.06]} className='cin-eyebrow cin-eyebrow--light'>
          Sicherheit für HR
        </Line>
        <Line at={[0.02, 0.1]} className='cin-title'>
          Sicher. <span className='cin-muted-light'>Von Anfang an.</span>
        </Line>
      </div>

      <div
        className='cin-strip'
        style={{
          '--count': CARDS.length,
          ...prog([0.1, 0.94]),
          transform:
            'translateX(calc(var(--strip-start) - var(--p) * (var(--count) * var(--card) + (var(--count) - 1) * var(--gap) - 100cqw + 2 * var(--strip-start))))'
        }}
      >
        {CARDS.map(({ Icon, tone, title, text }) => (
          <article key={title} className={`cin-card cin-card--${tone}`}>
            <Icon className='cin-card__icon' />
            <div>
              <h3 className='cin-card__title'>{title}</h3>
              <p className='cin-card__text'>{text}</p>
            </div>
          </article>
        ))}
      </div>
    </div>
  )
}
